/**
 * The processing outcome of one file inside an upload batch, as the
 * server words it.
 *
 * The display wording differs on purpose: `Processed` reads as
 * "Completed" and `Pending` reads as "Processing", so the labels live in
 * the translation mapper and not here.
 */
export enum UploadItemStatus {

    /** The file was parsed and stored. Shown as "Completed". */
    Processed = 'Processed',

    /** The file was rejected. The reason is in the item's details. */
    Failed = 'Failed',

    /** The file is still queued or being parsed. Shown as "Processing". */
    Pending = 'Pending',

}

/**
 * Union accepting both the enum members and the raw server strings, so a
 * status the app does not know yet still travels through the models.
 */
export type IUploadItemStatus = UploadItemStatus | 'Processed' | 'Failed' | 'Pending';
